import React from 'react';

const PhoneNumBanner = () => {
  return (
    <div className="phone-number-banner">
      <div className="margin-container-20">
        Not sure which check type is right for you? Call us at (866) 570-3842.
      </div>
    </div>
  );
};

export default PhoneNumBanner;
